export const ingredients = [
  {
    id: 'main',
    items: [
      {
        name: 'Olive oil (extra virgin)',
        number: 1,
        unit: 'Tbsp'
      },
      {
        name: 'Pancetta',
        number: '6-8',
        unit: 'oz',
        numberMetric: 170,
        unitMetric: 'g',
        preparation: 'small cubes'
      },
      {
        name: 'Yellow onion',
        number: 1,
        unit: 'small'
      },
      {
        name: 'Red pepper flakes',
        number: 1,
        unit: 'tsp'
      },
      {
        name: 'Salt',
        note: 'I recommend Diamond Crystal kosher salt'
      },
      {
        name: 'Garlic',
        number: 3,
        unit: 'cloves',
        preparation: 'finely sliced'
      },
      {
        name: 'Tomato paste',
        number: 2,
        unit: 'Tbsp'
      },
      {
        name: 'Crushed San Marzano or Italian plum tomatoes',
        number: 1,
        unit: '28oz can',
        numberMetric: 1,
        unitMetric: '794g can'
      },
      {
        name: 'Black pepper (freshly ground)'
      },
      {
        name: 'Rigatoni',
        number: 1,
        unit: 'lb',
        numberMetric: 450,
        unitMetric: 'g'
      },
      {
        name: 'Pecorino romano cheese',
        number: 1,
        unit: 'oz',
        numberMetric: 28,
        unitMetric: 'g',
        preparation: 'grated',
        note: 'roughly ¼ cup, plus more for serving'
      }
    ]
  }
]